import React, { useEffect, useRef } from "react";
import { LogoLink } from "../../LogoLink";
import { CalendarDay, PrayerHour } from "../../calendar/utils";
import { HORIZONTAL_RULE_COLOR } from "../../tokens";
import { LegacyTextBlock } from "./LegacyTextBlock";

export const Footer: React.FC<{ day: CalendarDay; hour: PrayerHour }> = (
    props
) => {
    const { day, hour } = props;

    const mailRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (mailRef.current) {
            mailRef.current.href =
                "mailto:" + ["contact", "singtheoffice.com"].join("@");
        }
    }, []);

    return (
        <div style={{ paddingBottom: 32 }}>
            <LegacyTextBlock>
                <div
                    style={{
                        borderTop: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                        paddingTop: 32,
                        paddingBottom: 32,
                        textAlign: "center",
                    }}
                >
                    <div
                        style={{
                            paddingBottom: 16,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <LogoLink />
                    </div>
                    If you found any errors, or have any comments or
                    suggestions, help us out by{" "}
                    <a
                        style={{ textDecoration: "underline" }}
                        type="mailto"
                        ref={mailRef}
                    >
                        contacting&nbsp;us.
                    </a>
                </div>
            </LegacyTextBlock>
        </div>
    );
};
